import React from 'react'
import { footerPrivacyLinkData } from '../helper/Helper'
import { Link } from 'react-router-dom'
function Footer() {
    return (
        <footer className='bg-haiti mt-3 mt-md-5'>
            <div className="wrapper mx-auto">
                <div className='border-ebonyclay border-bottom-0 border-end-0 border-start-0 d-flex flex-column-reverse flex-md-row gap-1 justify-content-between align-items-center py-2 py-sm-3 py-md-4'>
                    <p className='text-white fs-16 m-0'>Copyright © 2024, <span className='text-redribbon'>Casinio</span> - All Right Reserved</p>

                    <div className='d-flex flex-column-reverse flex-sm-row align-items-center gap-1 gap-sm-2 gap-lg-4'>
                        <p className='text-white fs-16 opacity-75 m-0'>Powered by Atomgaming88</p>
                        <ul className='list-unstyled d-flex gap-2 gap-lg-4 m-0'>
                            {footerPrivacyLinkData.map((data, index) => {
                                return (
                                    <li key={index}>
                                        <Link to={data.link} className='text-decoration-none text-white white-dropshadow-hover ease-in-out3ms fs-16'>{data.title}</Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer